import { render } from "./app-logo-powered-by-swipe-light.vue?vue&type=template&id=11305539"
const script = {}

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/image/app-logo-powered-by-swipe-light.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "11305539"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('11305539', __exports__)) {
    console.log('reload')
    api.reload('11305539', __exports__)
  }
  
  module.hot.accept("./app-logo-powered-by-swipe-light.vue?vue&type=template&id=11305539", () => {
    console.log('re-render')
    api.rerender('11305539', render)
  })

}


export default __exports__